import angular from 'angular';
import _ from 'lodash';
import $ from 'jquery';

angular.module('webTools').directive('wtImportDialog', ['$timeout', '$q', '$http', 'Import', 'File', 'ModalWindow',
    function ($timeout, $q, $http, Import, File, ModalWindow) {
        return {
            restrict: 'E',
            replace: true,
            transclude: false,
            template: '<div style="width:100%;height:100%;background-color:#eee"><div style="height:100%" id="flowElement" flow-drop flow-init="{target: \'/api/upload/uploadfile\', testChunks: false, simultaneousUploads: 1, generateUniqueIdentifier: checkUnique}" flow-file-added="fileAdded($file, $event, $flow)", flow-complete="complete()">' +
                        '<div style="height:100%;padding-bottom:70px;box-sizing:border-box" id="import-tabstrip" kendo-tab-strip="kendo.tabstrip" k-animation="false" k-on-select="tabSelect(kendoEvent)">' +
                            '<ul>' +
                                '<li id="generalTab" class="k-state-active">General</li>' +
                                '<li id="advancedTab">Advanced</li>' +
                                '<li id="notificationTab">Notifications</li>' +
                                '<li id="workflowTab">Workflow</li>' +
                            '</ul>' +
                            '<div id="generalTab" style="box-sizing:border-box;overflow-x:hidden;overflow-y:auto;height:100%;position:relative">' +
                                '<div style="text-align:bottom;margin-bottom: 2px" class="clearfix">' +
                                    '<span style="font-size:11px;display:inline-block;text-align:bottom;margin: 10px 0 0 1px">{{f.$flow.files.length}} {{ f.$flow.files.length === 1 ? \'File\' : \'Files\'}}:</span>' +
                                    '<div flow-btn class="add-file" style="font-size:11px;display:inline-block;">+ Add File</div>' +
                                '</div>' +
                                '<ul class="upload-list">' +
                                    '<li ng-repeat="file in $flow.files">' +
                                        '<div style="position:relative;width:100%;height:100%;z-index:10;padding-right: 85px;box-sizing: border-box">' +
                                            '<div class="file-icon-small files-small-{{file.name.split(\'.\').pop();}}" style="margin:5px 0 0 5px;"></div>' +
                                            '<span class="upload-filename">{{file.relativePath.split(\'/\').join(\'\\\\\')}}</span>' +
                                            '<span style="position:absolute;right:20px;top:8px;">{{fileService.getReadableFileSize(file.size)}}</span>' +
                                            '<span style="position:absolute;right:5px;top:7px;" ng-click="file.cancel()" >x</span>' +
                                        '</div>' +
                                    '</li>' +
                                '</ul>' +
                                '<span style="font-size:11px;display:block;margin: 0 0 2px 1px">Profile:</span>' +
                                '<input style="width:100%;margin-bottom:5px"' +
                                        'kendo-drop-down-list="kendo.importProfileDropDown"' +
                                        'k-data-source="profileList"' +
                                        'k-data-text-field="\'ProfileID\'"' +
                                        'k-on-data-bound="profilesLoaded()"' +
                                        'k-data-value-field="\'ProfileID\'"' +
                                        'k-on-change="loadProperties()" />' +
                                '<span style="font-size:11px;display:block;margin: 0 0 2px 1px">Properties:</span>' +
                                '<div class="import-profile-container" style="overflow:show">' +
                                    '<wt-property-list template="/partials/property-list-import.html" properties-control="propertiesControl" profile-name="selectedProfile" profile-property-values="profilePropertyValues"></wt-property-list>' +
                                '</div>' +
                                '<div style="padding: 2px 0; margin: 2px 0;">' +
                                    '<span style="font-size:11px;margin-bottom: 2px">Description:</span>' +
                                    '<input ng-model="importSettings.Description" class="import-text-long"/>' +
                                '</div>' +
                                '<div style="padding: 2px 0; margin: 2px 0;">' +
                                    '<span style="font-size:11px;margin-bottom: 2px">Version Notes:</span>' +
                                    '<input ng-model="importSettings.VersionNotes" class="import-text-long"/>' +
                                '</div>' +
                          '</div>' +
                          '<div id="advancedTab" style="box-sizing:border-box;overflow-x:hidden;overflow-y:auto;height:100%;padding-bottom:25px;position:relative">' +
                                '<div style="margin-top: 15px;">' +
                                    '<span class="input-label">AutoName Template</span>' +
                                    '<input id="autoName" style="width: 100%;" kendo-drop-down-list ng-model="importSettings.AutoName" k-data-source="autoNameList" k-data-text-field="\'AutoNameId\'" k-data-value-field="\'AutoNameId\'" />' +
                                '</div>' +
                                '<div style="margin-top: 10px;">' +
                                    '<span class="input-label">AutoPath Template</span>' +
                                    '<input id="autoPath" style="width: 100%;" kendo-drop-down-list ng-model="importSettings.AutoPath" k-data-source="autoPathList" k-data-text-field="\'AutoPathId\'" k-data-value-field="\'AutoPathId\'" />' +
                                '</div>' +
                                '<div style="margin-top: 10px;">' +
                                    '<span class="input-label">Record Policy</span>' +
                                    '<input id="recordPolicy" style="width: 100%;" kendo-drop-down-list ng-model="importSettings.RecordPolicy" k-select="recordPolicySelect" k-data-source="policyList" k-data-text-field="\'PolicyId\'" k-data-value-field="\'PolicyId\'" />' +
                                '</div>' +
                                '<div style="margin-top: 10px;">' +
                                    '<span class="input-label">Record Policy Status</span>' +
                                    '<input id="policyStatus" style="width: 100%;" kendo-drop-down-list="kendo.policyStatus" ng-model="importSettings.RecordPolicyStatus" k-enabled="policyStatusEnabled" k-data-source="policyStatus" k-data-text-field="\'text\'" k-data-value-field="\'value\'" />' +
                                '</div>' +
                                '<div style="margin-top: 10px;">' +
                                    '<span class="input-label">Existing File Behavior</span>' +
                                    '<input id="existingFile" style="width: 100%;" kendo-drop-down-list ng-model="importSettings.ExistingFileBehavior" k-data-source="existingFileBehavior" k-data-text-field="\'text\'" k-data-value-field="\'value\'" />' +
                                '</div>' +
                                '<ul class="checkbox-list" style="padding:0">' +
                                    '<li class="clearfix" style="display: block;width:100%;padding:2px 0">' +
                                        '<wt-form-checkbox model="importSettings.FullText" bind-to-parent="true"></wt-form-checkbox>' +
                                        '<span>Enable full text searches</span>' +
                                    '</li>' +
                                    '<li class="clearfix" style="display: block;width:100%;padding:2px 0">' +
                                        '<wt-form-checkbox model="importSettings.CreateNewVersion" bind-to-parent="true"></wt-form-checkbox>' +
                                        '<span>Create new version of the document upon check-in</span>' +
                                    '</li>' +
                                    '<li class="clearfix" style="display: block;width:100%;padding:2px 0">' +
                                        '<wt-form-checkbox model="importSettings.ExtractZip" bind-to-parent="true"></wt-form-checkbox>' +
                                        '<span>Extract zip archives on import</span>' +
                                    '</li>' +
                                    '<li class="clearfix" style="display: block;width:100%;padding:2px 0">' +
                                        '<wt-form-checkbox model="importSettings.MaintainZipStructure" bind-to-parent="true"></wt-form-checkbox>' +
                                        '<span>Maintain zip archive folder structure on import</span>' +
                                    '</li>' +
                                '</ul>' +
                          '</div>' +
                          '<div id="notificationsTab" style="box-sizing:border-box;overflow-x:hidden;overflow-y:auto;height:100%;padding-bottom:25px;position:relative">' +
                                '<div padding: 5px 0; margin: 4px 0;">' +
                                    '<div class="clearfix" style="margin:5px 0 2px 0;text-align:bottom">' +
                                        '<span style="font-size:11px;display:inline-block;margin-top:10px">To:</span>' +
                                        '<div style="float:right;display:inline-block;">' +
                                            '<span style="font-size:11px;display:inline-block;">Filter By: </span>' +
                                            '<input style="font-size:11px;" ' +
                                            ' kendo-drop-down-list' +
                                            ' ng-model="userFilter.filterColumn"' +
                                            ' k-data-source="filterOptions"' +
                                            ' k-data-text-field="\'text\'"' +
                                            ' k-data-value-field="\'value\'" />' +
                                        '</div>' +
                                    '</div>' +
                                    '<wt-multiselect ng-model="importSettings.NotificationList" name="users" wt-data-source="users(q)" type-to-bind="true" auto-bind="false" auto-populate="false" filter-list="true" server-filtering="true"></wt-multiselect>' +
                                    '<span style="font-size:11px;margin-bottom: 2px;margin-top:10px;display:block">Subject:</span>' +
                                    '<input class="import-text-long" style="height:24px;" ng-model="importSettings.NotificationSubject" />' +
                                    '<span style="font-size:11px;margin-bottom: 2px;margin-top:10px;display:block">Message:</span>' +
                                    '<textarea class="upload-message-body" ng-model="importSettings.NotificationMessage"></textarea>' +
                                    '<div style="margin-top:10px">' +
                                        '<input type="radio" value="0" ng-model="importSettings.MessageOption">Send message with no file information<br />' +
                                        '<input type="radio" value="1" ng-model="importSettings.MessageOption">One message for each file<br />' +
                                        '<input type="radio" value="2" ng-model="importSettings.MessageOption">One message for all files<br />' +
                                    '</div>' +
                                '</div>' +
                            '</div>' +
                          '<div id="workflowTab" style="box-sizing:border-box;overflow-x:hidden;overflow-y:auto;height:100%;padding-bottom:25px;position:relative">' +
                                '<div style="margin-top: 17px;">' +
                                    '<span class="input-label">Select Route To Start</span>' +
                                    '<input id="route" style="width: 100%;" ng-model="importSettings.RouteID" k-select="routeSelect" kendo-drop-down-list="kendo.routeList" k-data-bound="routeDataBound" k-data-source="routeList" k-data-text-field="\'RouteName\'" k-data-value-field="\'RouteId\'" />' +
                                '</div>' +
                                '<div style="margin-top: 10px;">' +
                                    '<span class="input-label">Route Instance Name</span>' +
                                    '<input type="text" class="import-text-long" ng-model="importSettings.RouteName" />' +
                                '</div>' +
                                '<div style="margin-top: 10px;">' +
                                    '<span class="input-label">Request Message</span>' +
                                    '<textarea ng-model="importSettings.RequestMessage" class="upload-message-body"></textarea>' +
                                '</div>' +
                                    '<div style="margin-top:10px">' +
                                        '<input type="radio" value="0" ng-model="importSettings.RouteOption">One route instance per file<br />' +
                                        '<input type="radio" value="1" ng-model="importSettings.RouteOption">One route instance for all files<br />' +
                                    '</div>' +
                            '</div>' +
                        '</div>' +
            '<div style="position:absolute;right:0;bottom:0;position: absolute;width:100%;background:#eee;padding: 0 12px;">' +
                            '<input type="button" class="cancel-button" ng-click="$flow.cancel()" value="Cancel"/>' +
                            '<input id="submit" type="button" class="ok-button" ng-click="submitUpload()" value="Import"/>' +
                        '</div>' +
                      '</div>',
            scope: {
                droppedFiles: '=',
                importFolderSettings: '='
            },
            controller: ['$scope', '$rootScope', 'Dialog', '$ngRedux', function ($scope, $rootScope, Dialog, $ngRedux) {

                const store = $ngRedux.getState();

                $scope.kendo = $scope.kendo || {};
                $scope.propertiesControl = {};
                $scope.fileService = File;
                $scope.userFilter = $scope.userFilter || {};
                $scope.userFilter.filterColumn = 'displayname';

                $scope.importFolder = $rootScope.workingFolder;

                $scope.policyStatusEnabled = false;

                $scope.filterOptions = [
                    { text: 'Display Name', value: 'displayname' },
                    { text: 'User ID', value: 'id' },
                    { text: 'Department', value: 'department' },
                    { text: 'Job Title', value: 'title' },
                    { text: 'Manager', value: 'supervisor' }
                ];

                $scope.policyStatus = [
                    { text: 'Not Scheduled', value: '0' },
                    { text: 'Scheduled', value: '1' },
                    { text: 'On Legal Hold', value: '2' },
                    { text: 'Expired', value: '3' }
                ];

                $scope.existingFileBehavior = [
                    { text: 'Replace', value: 'replace' },
                    { text: 'Create New Version', value: 'new' },
                    { text: 'Create Copy', value: 'copy' },
                    { text: 'Auto Increment Filename', value: 'increment' }
                ];

                $scope.fileAdded = function ($file) {
                    if ($file.size > store.app.maxFileSize * 1024) {
                        ModalWindow.openNotification('File exceeds maximum allowed file size.');
                        return false;
                    }
                }

                $scope.maxChunkSize = _.find($scope.importFolderSettings, { Setting: 'ChunkSize' });

                var autoNameTemplate = _.find($scope.importFolderSettings, { Setting: 'AutoNameTemplate' });
                var autoPath = _.find($scope.importFolderSettings, { Setting: 'AutoPathTemplate' });
                var policyId = _.find($scope.importFolderSettings, { Setting: 'PolicyID' });
                var policyStatus = _.find($scope.importFolderSettings, { Setting: 'PolicyStatus' });
                var workflowRoute = _.find($scope.importFolderSettings, { Setting: 'Workflow Route' });
                var workflowInstanceOption = _.find($scope.importFolderSettings, { Setting: 'Workflow Instance Option' });

                autoNameTemplate = autoNameTemplate ? autoNameTemplate.Value : '-- Select AutoName --';
                autoPath = autoPath ? autoPath.Value : '';
                policyId = policyId ? policyId.Value : '-- No Policies --';
                policyStatus = policyStatus ? policyStatus.Value : '';
                workflowRoute = workflowRoute ? workflowRoute.Value : '';
                workflowInstanceOption = workflowInstanceOption ? workflowInstanceOption.Value : '1';

                if (policyStatus) { $scope.policyStatusEnabled = true; }

                $scope.importSettings = {
                    FolderId: $rootScope.workingFolder,
                    ProfileName: '',
                    Properties: [],
                    Description: '',
                    VersionNotes: '',
                    AutoName: autoNameTemplate,
                    AutoPath: autoPath,
                    RecordPolicy: policyId,
                    RecordPolicyStatus: policyStatus,
                    ExistingFileBehavior: _.find($scope.importFolderSettings, { Setting: 'ExistingFiles' }).Value,
                    FullText: true,
                    CreateNewVersion: true,
                    ExtractZip: _.find($scope.importFolderSettings, { Setting: 'ExtractZip' }).Value,
                    MaintainZipStructure: _.find($scope.importFolderSettings, { Setting: 'MaintainZipStructure' }).Value,
                    NotificationSubject: '',
                    NotificationMessage: '',
                    NotificationList: [],
                    MessageOption: '2',
                    RouteID: workflowRoute,
                    RouteName: '',
                    RequestMessage: '',
                    RouteOption: workflowInstanceOption
                }

                $scope.setDefault = (e) => {
                    console.log(e)
                }

                $scope.complete = function () {

                    if ($scope.f.$flow.files.length > 0) {
                        angular.element('#statusMessage').html('Importing files into Document Locator...')

                        Import.importFiles($scope.importSettings).then(function (data) {

                            $('#importProgressDialog').data('kendoWindow').close();

                            if (data.Message === "OK") {
                                $rootScope.$broadcast('reloadGrid');
                            } else {
                                ModalWindow.openNotification("<strong>Import Failed</strong><br><br>" + data.Message);
                            }
                        });
                    } else {
                        Import.cancelUpload().then(function (data) { });
                    }
                }

                $scope.checkUnique = function (file) {
                    _.each($scope.f.$flow.files, function (f) {
                        if (f.name === file.name) { ModalWindow.openNotification('A file with the name "' + file.name + '" has already been added.'); }
                    })

                    var relativePath = file.relativePath || file.webkitRelativePath || file.fileName || file.name;
                    var identifier = relativePath.replace(/[^0-9a-zA-Z_-]/img, '');
                    return identifier;
                }

                $scope.$watch(function () { return $scope.f.$flow.files.length }, function (newValue, oldValue) {
                    if (newValue === 0) {
                        angular.element('#submit').addClass('disabled');
                    } else {
                        angular.element('#submit').removeClass('disabled');
                    }
                })

                $scope.profilesLoaded = function (e) {
                    $scope.selectedProfile = $scope.kendo.importProfileDropDown.value();
                }

                $scope.routeDataBound = function () {
                    $timeout(() => {
                        var selectedItem = $("#route-list").children(".k-list-scroller").children('ul').children('li.k-state-selected');

                        if(selectedItem.length === 0) {
                            selectedItem = $("#route-list").children(".k-list-scroller").children('ul').children('li:first-child')
                            $scope.kendo.routeList.select(0);
                        }

                        $scope.kendo.routeList.trigger('select', { item: selectedItem });
                    })

                }

                const state = $ngRedux.getState();
                const endpoint = state.app.endpoint;

                $scope.autoNameList = {
                    transport: {
                        read: {
                            url: `${endpoint ? endpoint : ''}/api/import/getAutoNameTemplates?nocache=` + new Date().getTime(),
                            contentType: 'application/json'
                        },
                        parameterMap: function (data, operation) {
                            data = $.extend({ folderId: $rootScope.workingFolder }, data);
                            return data;
                        }
                    }
                };

                $scope.autoPathList = {
                    transport: {
                        read: {
                            url: `${endpoint ? endpoint : ''}/api/import/getAutoPathTemplates?nocache=` + new Date().getTime(),
                            contentType: 'application/json'
                        },
                        parameterMap: function (data, operation) {
                            data = $.extend({ folderId: $rootScope.workingFolder }, data);
                            return data;
                        }
                    }
                };

                $scope.policyList = {
                    transport: {
                        read: {
                            url: `${endpoint ? endpoint : ''}/api/import/getPolicyList?nocache=` + new Date().getTime(),
                            contentType: 'application/json'
                        },
                        parameterMap: function (data, operation) {
                            data = $.extend({ folderId: $rootScope.workingFolder }, data);
                            return data;
                        }
                    }
                };

                $scope.routeList = {
                    transport: {
                        read: {
                            url: `${endpoint ? endpoint : ''}/api/workflow/getworkflowroutes?nocache=` + new Date().getTime(),
                            contentType: 'application/json'
                        },
                        parameterMap: function (data, operation) {
                            data = $.extend({ folderId: $rootScope.workingFolder }, data);
                            return data;
                        }
                    }
                };

                function formatNumber(num) {
                    var str = "00" + num
                    return str.substr(str.length - 2)
                }

                $scope.routeSelect = function (e) {

                    var item = this.dataItem(e.item.index()) || {};
                    var routeName = item.RouteName;
                    var routeId = item.RouteId;

                    if (routeId !== '0') {

                        var todayDate = new Date()
                        var todayHour = todayDate.getHours()
                        var todayMonth = todayDate.getMonth() + 1
                        var AMPM = "AM"
                        if (todayHour > 12) {
                            todayHour -= 12
                            AMPM = "PM"
                        }
                        routeName = routeName + " " +
                            todayMonth + "/" + formatNumber(todayDate.getDate()) + "/" + todayDate.getFullYear() + " " +
                            todayHour + ":" + formatNumber(todayDate.getMinutes()) + ":" + formatNumber(todayDate.getSeconds()) + " " + AMPM
                    } else {
                        routeName = '';
                    }

                    $scope.importSettings.RouteName = routeName;
                }

                $scope.recordPolicySelect = function (e) {
                    var item = this.dataItem(e.item.index());

                    if (item.PolicyId !== '-- Select Policy --') {
                        $scope.kendo.policyStatus.enable(true);
                    } else {
                        $scope.kendo.policyStatus.select(0);
                        $scope.kendo.policyStatus.enable(false);
                    }
                }

                $scope.users = function (q) {

                  var promises = {
                    deferred: $q.defer(),
                    canceler: $q.defer()
                  }

                    $http.get('/api/users/getusers', { params: { folderId: $rootScope.workingFolder, query: q, column: $scope.userFilter.filterColumn } })
                        .then(function (response) {
                            let data = response.data;
                          promises.deferred.resolve(data);
                        })

                  return promises;

                };

                $scope.workingFolder = $rootScope.workingFolder;
                $scope.kendo = {};

                $scope.loadProperties = function () {
                    $scope.selectedProfile = $scope.kendo.importProfileDropDown.value();
                }

                $scope.profileList = {
                    transport: {
                        read: {
                            url: `${endpoint ? endpoint : ''}/api/profiles/getprofilelist`,
                            contentType: 'application/json',
                            dataType: 'json'
                        },
                        parameterMap: function (data, operation) {
                            data = $.extend({ folderId: $rootScope.workingFolder }, data);
                            return data;
                        }
                    }
                };

                $scope.showProcessingOverlay = function () {
                    angular.element('#importDialog').parent().append('<div class="processing-overlay"></div>')
                }

                $scope.removeProcessingOverlay = function () {
                    angular.element('.processing-overlay').remove();
                }

                $scope.submitUpload = function () {

                    if ($scope.f.$flow.files.length === 0) { return false; }

                    $scope.showProcessingOverlay();

                    $scope.importSettings.ProfileName = $scope.kendo.importProfileDropDown.value();
                  $scope.importSettings.Properties = $scope.propertiesControl.getPropertyValues(true, true, function () { $scope.removeProcessingOverlay(); });


                    if ($scope.importSettings.Properties.length > 0) {

                        Import.validateProperties($scope.importSettings.ProfileName, $scope.importSettings.Properties).then(function (data) {
                            if (data.Message !== "") {
                                ModalWindow.openNotification(data.Message, function () { $scope.removeProcessingOverlay(); });
                            } else {
                                $scope.startImport();
                            }
                        })
                    } else {
                        $scope.startImport();
                    }
                }

                $scope.startImport = function () {
                    $scope.importSettings.NotificationList = _.map($scope.importSettings.NotificationList, 'value').join(';');
                    $scope.importSettings.RecordPolicyStatus = $scope.kendo.policyStatus.value();

                    if ($scope.importSettings.Properties === false) {
                        return false;
                    } else {
                        if ($scope.f.$flow.files.length > 0) {
                            Dialog.openImportProgess($scope.f.$flow);
                            $scope.$emit('closeImportDialog');
                        }
                    }
                }

                $scope.setDefaultProfile = function () {
                    if (typeof $scope.kendo.importProfileDropDown !== 'undefined') {
                        $timeout(function () {
                            $scope.kendo.importProfileDropDown.value($scope.selectedProfile);
                        })
                    } else {
                        $timeout(function () { $scope.setDefaultProfile(); }, 100);
                    }
                }

                $scope.setDefaultProfile();

                $('#importDialog').data('kendoWindow').bind('resize', function (e) {

                  var dialog = $('#importDialog');

                  if (dialog.height() > 626) {
		            
		                var profileArea = $('.import-profile-container');
		                var messageArea = $('.upload-message-body');

		                profileArea.height(200 + (dialog.height() - 630))
		                messageArea.height(300 + (dialog.height() - 630))
                  }
		            });
            }],
            link: function (scope, element, attributes) {

                scope.f = element.find('#flowElement').scope();

                $timeout(function () {
                    scope.f.$flow.addFiles(scope.droppedFiles);
                })
            }
        }
    }
]);

angular.module('webTools').factory('Dialog', ['$rootScope', '$compile', '$window', 'Import', 'Auth', 'ModalWindow', 'Project', '$location', '$ngRedux',
    function ($rootScope, $compile, $window, Import, Auth, ModalWindow, Project, $location, $ngRedux) {
        return {
            openImport: function (files) {

                var newScope = $rootScope.$new();
                var w = angular.element($window);
                const store = $ngRedux.getState();

                var resizeDialog = function () {
                  if (window.innerHeight < 634) {
                    $('.k-window').height(window.innerHeight - 50 + "px");
                  } else {
                    $('.k-window').height(634 + "px");
                  }
                }

                var kendoWindow = $('<div id="importDialog" style="overflow:hidden" />').kendoWindow({
                    resizable: true,
                    width: '600px',
                    height: '634px',
                    minWidth: '600px',
                    modal: true,
                    draggable: true,
                    title: 'WebTools Import',
                    actions: ['Maximize', 'Close'],
                    dragend: () => { ModalWindow.restrictWindowDragging('importDialog') },
                    open: function (e) {
                        this.wrapper.css({ 'background-color': '#eee', 'top': '10px' });

                    w.bind('resize', resizeDialog);

                    if (window.innerHeight < 625) {
                      $('.k-window').height(window.innerHeight - 50 + "px");
                    }
                  },
                  close: function (e) {
                      w.unbind('resize', resizeDialog);
                      newScope.$destroy();
                      kendoWindow.data("kendoWindow").destroy();
                  },
                  activate: function () {
                      $('.k-overlay').attr('ondrop', 'event.dataTransfer.dropEffect="none";event.stopPropagation(); event.preventDefault();')
                                      .attr('ondragenter', 'event.dataTransfer.dropEffect="none"; event.stopPropagation(); event.preventDefault();')
                                      .attr('ondragover', 'event.dataTransfer.dropEffect="none";event.stopPropagation(); event.preventDefault();');

                    }
                });

                if (Auth.isWebView() || store.app.webViewMode) {
                    alert('You do not have permission to import files.')
                }

                Import.getFolderSettings($rootScope.workingFolder).then(function (data) {

                    newScope.wtDroppedFiles = files;
                    newScope.wtImportSettings = data;

                    var el = $compile('<wt-import-dialog dropped-files="wtDroppedFiles" import-folder-settings="wtImportSettings"></wt-import-dialog>')(newScope);

                    newScope.$on('closeImportDialog', function () {
                        $('#importDialog').data('kendoWindow').close().destroy();
                    })

                    files = null;

                    kendoWindow.data("kendoWindow").content(el).center().open();

                    kendoWindow
                        .find(".cancel-button")
                        .click(function () {
                            kendoWindow.data("kendoWindow").close().destroy();
                        })
                        .end()

                });
            },
            openImportProgess: function (flow) {

                var newScope = $rootScope.$new();

                var kendoWindow = $('<div id="importProgressDialog" />').kendoWindow({
                    resizable: false,
                    width: '600px',
                    minWidth: '600px',
                    modal: true,
                    draggable: true,
                    title: 'WebTools Import',
                    actions: [],
                    open: function (e) {
                        this.wrapper.css({ top: '100px' })
                    },
                    close: function (e) {
                        newScope.$destroy();
                        kendoWindow.data("kendoWindow").destroy();
                    },
                    activate: function () {
                        $('.k-overlay').attr('ondrop', 'event.dataTransfer.dropEffect="none";event.stopPropagation(); event.preventDefault();')
                            .attr('ondragenter', 'event.dataTransfer.dropEffect="none"; event.stopPropagation(); event.preventDefault();')
                            .attr('ondragover', 'event.dataTransfer.dropEffect="none";event.stopPropagation(); event.preventDefault();');

                        $('#importProgressDialog').parent().attr('ondrop', 'event.dataTransfer.dropEffect="none";event.stopPropagation(); event.preventDefault();')
                            .attr('ondragenter', 'event.dataTransfer.dropEffect="none"; event.stopPropagation(); event.preventDefault();')
                            .attr('ondragover', 'event.dataTransfer.dropEffect="none";event.stopPropagation(); event.preventDefault();')
                    }
                });

                var w = angular.element($window);

              var reCenter = function () {
                kendoWindow.data("kendoWindow").center().wrapper.css({ top: '100px' });
              }

              w.bind('resize', reCenter);

                newScope.flow = flow;

                var el = $compile('<wt-upload-progress flow-object="flow"></wt-upload-progress>')(newScope);

                kendoWindow.data("kendoWindow")
                    .content(el)
                    .center().open();

                newScope.$on("$destroy", function () {
                  w.unbind('resize', reCenter);
                });

                kendoWindow
                    .find(".cancel-button")
                        .click(function () {
                          w.unbind('resize', reCenter);
                            kendoWindow.data("kendoWindow").close().destroy();
                        })
                        .end()

                kendoWindow
                    .find(".done-button")
                        .click(function () {
                          w.unbind('resize', reCenter);
                            kendoWindow.data("kendoWindow").close().destroy();
                        })
                        .end() 
            },
            openDownload: function (downloadType, isFolder, files, isProject) {

                var newScope = $rootScope.$new();

                var reCenter = function () {
                  kendoWindow.data("kendoWindow").center().wrapper.css({ top: '100px' });
                }

                var kendoWindow = $('<div id="downloadDialog" />').kendoWindow({
                    resizable: false,
                    width: '400px',
                    minWidth: '400px',
                    modal: true,
                    draggable: true,
                    title: 'File Options',
                    open: function (e) {
                        this.wrapper.css({ top: '100px' })
                    },
                    close: function (e) {
                        newScope.$destroy();
                        kendoWindow.data("kendoWindow").destroy();
                    },
                    activate: function () {
                        $('.k-overlay').attr('ondrop', 'event.dataTransfer.dropEffect="none";event.stopPropagation(); event.preventDefault();')
                            .attr('ondragenter', 'event.dataTransfer.dropEffect="none"; event.stopPropagation(); event.preventDefault();')
                            .attr('ondragover', 'event.dataTransfer.dropEffect="none";event.stopPropagation(); event.preventDefault();');

                        $('#downloadDialog').parent().attr('ondrop', 'event.dataTransfer.dropEffect="none";event.stopPropagation(); event.preventDefault();')
                            .attr('ondragenter', 'event.dataTransfer.dropEffect="none"; event.stopPropagation(); event.preventDefault();')
                            .attr('ondragover', 'event.dataTransfer.dropEffect="none";event.stopPropagation(); event.preventDefault();')

                        kendoWindow.find('.ok-button').click(function () {
                          w.unbind('resize', reCenter);
                            kendoWindow.data("kendoWindow").close().destroy();
                        }).end()
                    }
                });

                var w = angular.element($window);

              w.bind('resize', reCenter);

                newScope.files = files;
                newScope.isFolder = isFolder;
                newScope.downloadType = downloadType;
                newScope.isProject = isProject;

                var dialogTemplate = '<wt-download-dialog is-project="isProject" is-folder="isFolder" download-type="downloadType" file-list="files"></wt-download-dialog>';

                var el = $compile(dialogTemplate)(newScope);

                kendoWindow.data("kendoWindow")
                    .content(el)
                    .center().open();

                newScope.$on("$destroy", function () {
                  w.unbind('resize', reCenter);
                });
            },
            openNewProject: function () {

                var newScope = $rootScope.$new();
                var self = this;

                var kendoWindow = $('<div id="newProjectDialog" style="padding:0"/>').kendoWindow({
                    resizable: false,
                    width: '400px',
                    minWidth: '400px',
                    modal: true,
                    draggable: false,
                    title: 'New Project',
                    open: function (e) {
                        this.wrapper.css({ top: '20%' })
                    },
                    close: function (e) {
                        newScope.$destroy();
                        kendoWindow.data("kendoWindow").destroy();
                    },
                    activate: () => {
                        var el = document.getElementById('projectName');

                        el.focus();
                    }
                });

                var windowContent = '<style>' +
                    '#projectName { border: 1px solid #ccc; }' +
                    '</style>' +
                    '<div id="linkDialog" style="background-color:#fff;padding: 10px 10px 25px 10px;">' +
                    '<div>' +
                    '<input id="projectName" class="login-input" type="text" style="width:100%;" value="" placeholder="Project Name">' +
                    '</div>' +
                    '<input id="submit" type="button" class="ok-button" ng-click="submitUpload()" value="Save" style="margin-right:0" />' +
                    '<input type="button" class="cancel-button" ng-click="$flow.cancel()" value="Cancel" />' +
                    '</div>';

                kendoWindow.data("kendoWindow").title('New Project').content(windowContent).center().open();

                kendoWindow.find('.cancel-button').click(function () {
                    kendoWindow.data("kendoWindow").close().destroy();
                })

                kendoWindow.find('.ok-button').click(function () {

                    var projectName = angular.element('#projectName').val();

                    Project.createProject($rootScope.workingFolder, projectName).then(function (response) {
                        $location.url(`/projects?project=${response.data.id}&page=1`)
                        self.openProjectEditor(response.data.id);
                        kendoWindow.data("kendoWindow").close().destroy();
                    })
                })
            },
            openProjectEditor: function (projectId) {

                var newScope = $rootScope.$new();

                const resizeDialog = () => $('#projectEditorTabstrip .k-grid-content').height($('.project-tab-container').height() - 150 + "px");

                var kendoWindow = $('<div id="projectEditorDialog" style="padding:0"/>').kendoWindow({
                    resizable: false,
                    width: '800px',
                    minWidth: '800px',
                    height: '575px',
                    modal: true,
                    draggable: true,
                    title: 'Edit Project',
                  dragend: () => { ModalWindow.restrictWindowDragging('projectEditorDialog') },
                  open: () => {
                    if (window.innerHeight < 625) {
                      $('.k-window').height(window.innerHeight - 50 + "px");
                    }
                  },
                  close: function (e) {

                    if (newScope.dirty === true) {
                          e.preventDefault();
                        ModalWindow.openConfirmation('You have unsaved changes. Close anyway?', function () {
                            newScope.$destroy();
                            kendoWindow.data("kendoWindow").destroy();
                          });
                      } else {
                          newScope.$destroy();
                          kendoWindow.data("kendoWindow").destroy();
                    }

                    window.setTimeout(() => $rootScope.$broadcast('reloadGrid'))
                  },
                  activate: function () {
                      kendoWindow.find('.cancel-button').click(function () {
                          kendoWindow.data("kendoWindow").close();
                      })
                    resizeDialog();
                  },
                  resize: () => {
                    resizeDialog()
                  }
                });

                Project.getProjectInfo(projectId).then(function (response) {

                    response.data.projectId = projectId;
                    newScope.projectInfo = response.data;
                    newScope.dirty = false;

                    var dialogTemplate = '<wt-project-editor project-info="projectInfo" dirty="dirty"></wt-project-editor>';

                    var el = $compile(dialogTemplate)(newScope);

                    kendoWindow.data("kendoWindow").content(el).center().open();

                    newScope.$on('closeImportDialog', function () {
                        $('#importDialog').data('kendoWindow').close().destroy();
                    })
                });
            }
        }
    }
]);

angular.module('webTools').service('Import', ['$q', '$http',
    function ($q, $http) {
        return {
            importFiles: function (settings) {

                var defer = $q.defer();

                $http.post('/api/upload/importfiles', settings)
                    .then(function (response) {
                        let data = response.data;
                        defer.resolve(data);
                    })

                return defer.promise;
            },
            cancelUpload: function () {

                var defer = $q.defer();

                $http.post('/api/upload/cancelUpload')
                    .then(function (response) {
                        let data = response.data;
                        defer.resolve(data);
                    })

                return defer.promise;
            },
            getFolderSettings: function (id) {

                var defer = $q.defer();

                $http.get('/api/import/GetFolderSettings', { params: { folderId: id } })
                    .then(function (response) {
                        let data = response.data;
                        defer.resolve(data);
                    })

                return defer.promise;
            },
            validateProperties: function (profile, properties) {

                var defer = $q.defer();

                $http.post('/api/profiles/ValidatePropertyValues', { ProfileName: profile, Properties: properties })
                    .then(function (response) {
                        let data = response.data;
                        defer.resolve(data);
                    })

                return defer.promise;
            }
        }
    }
]);